import React from 'react';
import { Link} from 'react-feather';
import { ReactComponent as Exclamation } from 'assets/img/icons/v2/exclamation.svg'
import { ReactComponent as Pen } from 'assets/img/icons/v2/pen.svg'

function Icons(props) {
	const { type, size } = props;

	const LOGOS = {
		exclamation: <Exclamation width={size} height={size}/>,
		pen: <Pen width={size} height={size}/>,
		link: <Link size={size}/>,
	};

	return LOGOS[type] ?? LOGOS['link'];
}

export default Icons;
